module.exports = __webpack_public_path__ + "img/payment-method-2.dde04136.svg";